"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof2 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactTransitionGroup = require("../../utils/react/react-transition-group");
var _resizeObserver = _interopRequireDefault(require("../dom/resizeObserver"));
var _utils = require("../../utils");
var _PopLayer = _interopRequireDefault(require("../../layer/PopLayer"));
var _typeof = require("../data/typeof");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof2(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function contains(root, n) {
  var node = n;
  while (node) {
    if (node === root) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
}
var Trigger = /*#__PURE__*/function (_PureComponent) {
  function Trigger(_props) {
    var _props$visible;
    var _this;
    (0, _classCallCheck2.default)(this, Trigger);
    _this = _callSuper(this, Trigger, [_props]);
    (0, _defineProperty2.default)(_this, "popRef", /*#__PURE__*/_react.default.createRef());
    (0, _defineProperty2.default)(_this, "triggerRef", /*#__PURE__*/_react.default.createRef());
    (0, _defineProperty2.default)(_this, "popupContentRef", /*#__PURE__*/_react.default.createRef());
    (0, _defineProperty2.default)(_this, "delayTimer", null);
    (0, _defineProperty2.default)(_this, "isFocus", false);
    // 创建MutationObserver监听DOM树中的变化，包括元素的添加、删除、属性变化以及文本内容的变化。
    (0, _defineProperty2.default)(_this, "observer", null);
    (0, _defineProperty2.default)(_this, "disconnectObserver", function () {
      if (_this.observer) {
        _this.observer.disconnect();
        _this.observer = null;
      }
    });
    (0, _defineProperty2.default)(_this, "handleResize", function () {
      _this.forceAlign();
    });
    (0, _defineProperty2.default)(_this, "getTargetProps", function () {
      var props = {
        key: 'trigger'
      };
      if (_this.props.disabled) {
        return props;
      }
      if (_this.isShowPopLayerBy('hover')) {
        props.onMouseEnter = _this.handleMouseEnter;
        props.onMouseLeave = _this.handleMouseLeave;
      }
      if (_this.isShowPopLayerBy('click')) {
        props.onClick = _this.handleClick;
      }
      if (_this.isShowPopLayerBy('focus')) {
        props.onFocus = _this.handleFocus;
        props.onBlur = _this.handleBlur;
      }
      return props;
    });
    (0, _defineProperty2.default)(_this, "getPopLayerMouseEvent", function () {
      if (_this.isShowPopLayerBy('hover')) {
        return {
          onMouseEnter: _this.handlePopupMouseEnter,
          onMouseLeave: _this.handlePopupMouseLeave
        };
      }
      return null;
    });
    (0, _defineProperty2.default)(_this, "getVisible", function () {
      return 'visible' in _this.props ? _this.props.visible : _this.state.visible;
    });
    (0, _defineProperty2.default)(_this, "setPopLayerVisible", function (visible) {
      var _this$props = _this.props,
        onVisibleChange = _this$props.onVisibleChange,
        disabled = _this$props.disabled;
      var current = _this.state.visible;
      if (current !== visible && !disabled) {
        if (!('visible' in _this.props)) {
          _this.setState({
            visible: visible
          });
        }
        onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(visible);
      }
    });
    (0, _defineProperty2.default)(_this, "handleDocumentClick", function (event) {
      var onDocumentClick = _this.props.onDocumentClick;
      var visible = _this.state.visible;
      var target = event.target;
      var root = _this && (0, _utils.findDOMNode)(_this);
      var popupNode = _this.popRef.current && (0, _utils.findDOMNode)(_this.popRef.current);
      if (!contains(root, target) && !contains(popupNode, target) && visible) {
        _this.closePopLayer();
        onDocumentClick && onDocumentClick(visible);
      }
    });
    (0, _defineProperty2.default)(_this, "handleMouseEnter", function (e) {
      _this.fireTriggerEvents('onMouseEnter', e);
      _this.delaySetPopLayerVisible(true);
    });
    (0, _defineProperty2.default)(_this, "handleMouseLeave", function (e) {
      if (_this.isFocus) {
        return;
      }
      _this.fireTriggerEvents('onMouseLeave', e);
      _this.delaySetPopLayerVisible(false);
    });
    (0, _defineProperty2.default)(_this, "handleFocus", function (e) {
      _this.fireTriggerEvents('onFocus', e);
      _this.isFocus = true;
      _this.delaySetPopLayerVisible(true);
    });
    (0, _defineProperty2.default)(_this, "handleBlur", function (e) {
      _this.fireTriggerEvents('onBlur', e);
      _this.isFocus = false;
      _this.delaySetPopLayerVisible(false);
    });
    (0, _defineProperty2.default)(_this, "handleClick", function (e) {
      _this.fireTriggerEvents('onClick', e);
      _this.delaySetPopLayerVisible(true);
    });
    (0, _defineProperty2.default)(_this, "handlePopupMouseEnter", function () {
      _this.clearDelayTimer();
    });
    (0, _defineProperty2.default)(_this, "handlePopupMouseLeave", function (e) {
      var visible = _this.state.visible;
      var target = e.relatedTarget;
      var root = (0, _utils.findDOMNode)(_this);
      var popupNode = (0, _utils.findDOMNode)(_this.popRef.current);
      if (!contains(root, target) && !contains(popupNode, target) && visible) {
        _this.delaySetPopLayerVisible(false);
      }
      if (!popupNode) {
        console.warn('popupNode is null. if you are using react version 18 or above, the child must be inside a DOM element.');
      }
    });
    /**
     * 对外提供重新计算位置的方法
     * 解决自身内容高度变化需要重新计算位置
     */
    (0, _defineProperty2.default)(_this, "forceAlign", function () {
      if (_this.popRef.current) {
        _this.popRef.current.forceAlign();
      }
    });
    (0, _defineProperty2.default)(_this, "clearDelayTimer", function () {
      if (_this.delayTimer) {
        clearTimeout(_this.delayTimer);
        _this.delayTimer = null;
      }
    });
    (0, _defineProperty2.default)(_this, "fireTriggerEvents", function (type, e) {
      var children = _this.props.children;
      var childCallback = children && children.props && children.props[type];
      if (childCallback) {
        childCallback(e);
      }
      var callback = _this.props[type];
      if (callback) {
        callback(e);
      }
    });
    (0, _defineProperty2.default)(_this, "closePopLayer", function () {
      if (_this.isShowPopLayerBy('click')) {
        _this.delaySetPopLayerVisible(false);
      }
    });
    (0, _defineProperty2.default)(_this, "isShowPopLayerBy", function (act) {
      var trigger = _this.props.trigger;
      return Array.isArray(trigger) ? trigger.includes(act) : trigger === act;
    });
    (0, _defineProperty2.default)(_this, "delaySetPopLayerVisible", function (visible) {
      _this.clearDelayTimer();
      var _this$props2 = _this.props,
        delayShow = _this$props2.delayShow,
        delayHide = _this$props2.delayHide;
      var delay = visible ? delayShow : delayHide;
      if (delay) {
        _this.delayTimer = window.setTimeout(function () {
          _this.setPopLayerVisible(visible);
          _this.clearDelayTimer();
        }, delay);
      } else {
        _this.setPopLayerVisible(visible);
      }
    });
    _this.state = {
      visible: _props.defaultVisible && !_props.disabled,
      preVisible: _props.defaultVisible && !_props.disabled,
      shouldDisplay: (_props$visible = _props.visible) !== null && _props$visible !== void 0 ? _props$visible : _props.defaultVisible
    };
    return _this;
  }
  /*
   * 必须用 mousedown 代替 click，详见下面的例子
   * https://github.com/react-component/trigger/issues/50
   */
  (0, _inherits2.default)(Trigger, _PureComponent);
  return (0, _createClass2.default)(Trigger, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('mousedown', this.handleDocumentClick, false);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props3 = this.props,
        visible = _this$props3.visible,
        onChange = _this$props3.onChange;
      if (visible !== prevState.preVisible && visible !== undefined) {
        this.setState({
          visible: visible
        });
        if ((0, _typeof.isFunction)(onChange)) {
          onChange(visible);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('mousedown', this.handleDocumentClick, false);
      this.clearDelayTimer();
      this.disconnectObserver();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props4 = this.props,
        className = _this$props4.className,
        children = _this$props4.children,
        popup = _this$props4.popup,
        align = _this$props4.align,
        getContainer = _this$props4.getContainer,
        onAlign = _this$props4.onAlign,
        onMounted = _this$props4.onMounted,
        zIndex = _this$props4.zIndex,
        timeout = _this$props4.timeout,
        CSSTransitionName = _this$props4.CSSTransitionName,
        autoDestroy = _this$props4.autoDestroy;
      var validChild = /*#__PURE__*/_react.default.isValidElement(children) ? children : /*#__PURE__*/_react.default.createElement("span", null, children);
      var validPopLayer = typeof popup === 'function' ? popup() : popup;
      var child = _react.default.Children.only(validChild);
      var triggerTargetProps = this.getTargetProps();
      var triggerNode = /*#__PURE__*/_react.default.cloneElement(child, triggerTargetProps);
      var mouseProps = this.getPopLayerMouseEvent();
      var visible = this.getVisible();
      var shouldDisplay = this.state.shouldDisplay;
      var cls = (0, _classnames.default)(validPopLayer.props.className);
      var popupContentNode;
      var originStyle = validPopLayer.props.style || {};
      var commonProps = _objectSpread(_objectSpread(_objectSpread({}, validPopLayer.props), mouseProps), {}, {
        className: cls
      });
      if (!visible && autoDestroy) {
        popupContentNode = null;
      } else {
        var displayStyle = !visible ? {
          display: shouldDisplay ? '' : 'none'
        } : {};
        popupContentNode = /*#__PURE__*/_react.default.cloneElement(validPopLayer, _objectSpread(_objectSpread({}, commonProps), {}, {
          style: _objectSpread(_objectSpread({}, originStyle), displayStyle)
        }));
      }
      var popupNode = popupContentNode ? ( /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
        in: visible,
        timeout: timeout,
        classNames: CSSTransitionName,
        unmountOnExit: autoDestroy,
        onExited: function onExited() {
          if (!autoDestroy) {
            _this2.setState({
              shouldDisplay: false
            });
          }
        },
        onEnter: function onEnter() {
          _this2.setState({
            shouldDisplay: true
          });
        }
      }, /*#__PURE__*/_react.default.createElement(_PopLayer.default, {
        key: "popup",
        className: className,
        ref: this.popRef,
        zIndex: zIndex,
        align: align,
        getContainer: getContainer,
        onAlign: onAlign,
        onMounted: onMounted,
        getTargetElement: function getTargetElement() {
          return (0, _utils.findDOMNode)(_this2);
        }
      }, popupContentNode))) : null;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_resizeObserver.default, {
        onResize: this.handleResize
      }, triggerNode), popupNode);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var visible = nextProps.visible;
      var preVisible = prevState.preVisible;
      if (visible !== preVisible) {
        return {
          preVisible: visible
        };
      }
      return null;
    }
  }]);
}(_react.PureComponent);
(0, _defineProperty2.default)(Trigger, "defaultProps", {
  trigger: 'hover',
  delayHide: 100,
  autoDestroy: false,
  disabled: false,
  timeout: 0
});
var _default = exports.default = Trigger;